import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import GraficaIGC from './graficaIGC';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(15),
        border: '1px solid #dadde9',
    },
}))(Tooltip);


export default function ChartIgc({ data, dataD, fechaIni, fechaFin, valorTotal }) {
    const series = [
        dataD[0]?.value1 === undefined ? 0 : dataD[0].value1,
        dataD[1]?.value2 === undefined ? 0 : dataD[1].value2,
        dataD[2]?.value3 === undefined ? 0 : dataD[2].value3,
        dataD[3]?.value4 === undefined ? 0 : dataD[3].value4,
        dataD[4]?.value5 === undefined ? 0 : dataD[4].value5,
    ];

    return (
        <>
            <Grid container spacing={2} alignItems="center" justifyContent="center">
                <Grid item>
                    <Grid item xs={12} sm container>
                        <Grid item xs container>
                            <Grid item xs>
                                <Grid item xs={12} sm container alignItems="center">
                                    <Grid item xs={12} sm container alignItems="center">
                                        <Typography align="center" alignItems="center" style={{ fontWeight: 'bold', fontSize: "30px" }}color='primary'>
                                            Porcentaje de Grasa Corporal
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="start" justifyContent="center" style={{ marginTop: '0%', marginLeft: "8px", width: '100%', height: '150px' }}>
                <Grid item>
                    <Grid item xs={3} sm container>
                        <Grid item xs container direction="column">
                            <Grid item xs={12} md={12} lg={12}>
                                <GraficaIGC series={series} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={3} style={{ marginLeft: '70%',marginTop:'-19.5%' ,zIndex:500}}>
                    <div style={{ display: 'flex', flexDirection: 'column'  }}>
                        <div style={{ marginBottom: '10px' }}>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"BAJO:"}</b>{' '}
                                            {"HOMBRES con valores menor a 11% y MUJERES con valores menores al 21%."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"NORMAL:"}</b>{' '}
                                            {"HOMBRES con valores entre 11% y 22% y MUJERES con valores entre 21% y 33%."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"ALTA:"}</b>{' '}
                                            {"HOMBRES con valores entre 22% y 28% y MUJERES con valores entre 33% y 39%."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"MUY ALTA:"}</b>{' '}
                                            {"HOMBRES con valores mayor a 28% y MUJERES con valores mayor a 39%."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"Si registro:"}</b>{' '}
                                            {"sin registro"}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </>
    );
}
